import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AmbulanceConfirmedComponent } from '../../../dashboard/assistances/ambulance-assistance/ambulance-confirmed/ambulance-confirmed.component';
import { MedicalCheckupConfirmedComponent } from '../../../dashboard/assistances/medical-checkup/medical-checkup-confirmed/medical-checkup-confirmed.component';

@Component({
  selector: 'app-service-confirm',
  standalone: true,
  imports: [
    CommonModule,
    AmbulanceConfirmedComponent,
    MedicalCheckupConfirmedComponent
  ],
  templateUrl: './service-confirm.component.html',
  styleUrls: ['./service-confirm.component.scss']
})
export class ServiceConfirmComponent implements OnInit {
  serviceType: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.serviceType = this.route.snapshot.paramMap.get('serviceType') || '';
  }

  isAmbulance(): boolean {
    return this.serviceType === 'Ambulancia';
  }

  isMedicalCheckup(): boolean {
    return this.serviceType === 'Check-up Médico' || this.serviceType === 'Check Up';
  }
}